import { useEffect, useState } from 'react'
// import { SearchBarAndFiltersOrganization } from '../SearchAndFilters/SearchBarAndFilterOrganization'
import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'

import useStyles from './useStyles'

import { useDispatch } from 'react-redux'
import { getAllLockedDeclarations, unLockEntityLegalDeclarations } from '../../../redux/actions/Declarations'
import { Button } from '@mui/material'
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined'
import { useNavigate, useParams } from 'react-router-dom'
import { getAllCustomerSupport, getAllUsersOfSuborganizations } from '../../../redux/actions/Suborganizations'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../redux/actions/app'
import { logEvent } from '../../../utils/LogEvents'

function DeclarationTable ({
  // rows,
  // setRows,
  setLoading,
  openFilterByType,
  setopenFilterByType,
  valueFilter,
  setvalueFilter
}) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [rows, setRows] = useState([])
  const [suborganizationUsers, setsuborganizationUsers] = useState([])
  const [customers, setCustomers] = useState([])

  const [allChecked, setAllChecked] = useState(false)
  const [elementsChecked, setElementsChecked] = useState([])
  const { id } = useParams()
  const navigate = useNavigate()

  const getUserName = (userId) => {
    const user = suborganizationUsers.find(
      (userInfo) =>
        userInfo.userId === userId)
    return user ? `${user.user.account.firstName} ${user.user.account.lastName}` : '- -'
  }
  const getCustomerName = (customerId) => {
    const customer = customers.find(
      (customerInfo) =>
        customerInfo.customerSuborganizationId === customerId)
    return customer.suborganizationName || '- -'
  }
  const getSuborganizationCustomer = async () => await dispatch(getAllCustomerSupport(id))

  const getUsers = async () => await dispatch(getAllUsersOfSuborganizations(id))

  const handleGetDeclarations = async () => {
    try {
      setCustomers(await getSuborganizationCustomer())
      setsuborganizationUsers(await getUsers())
      setRows(await dispatch(getAllLockedDeclarations(id)))
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(async () => {
    setLoading(true)
    await handleGetDeclarations()
    setLoading(false)
  }, [])

  useEffect(() => {
    if (elementsChecked.length === 0 && allChecked) {
      setAllChecked(false)
    }
    if (
      elementsChecked.length > 0 &&
      elementsChecked.length === rows.length &&
      !allChecked
    ) {
      setAllChecked(true)
    }
  }, [elementsChecked])

  const handleSuccess = () => {
    dispatch(setRequestTextSnackBar())
    dispatch(setSuccessTextSnackBar('Desbloqueo exitoso'))

    setTimeout(() => {
      navigate(0)
    }, 1000)
  }
  const handleButtonClick = async () => {
    try {
      if (elementsChecked.length > 0) {
        const selectedDeclarationsIds = elementsChecked.map(
          (index) => index.personalLegalDeclarationId
        )
        if (selectedDeclarationsIds.length > 0) {
          const response = await dispatch(unLockEntityLegalDeclarations(selectedDeclarationsIds))
          await logEvent('CGI - unLockDeclarations', {
            body: selectedDeclarationsIds,
            response: response
          })
          handleSuccess()
        }
      } else {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'No seleccionaste ninguna declaración para desbloquear'
          )
        )
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleUnLockSingleDeclaration = async (id) => {
    try {
      if (id) {
        const response = await dispatch(unLockEntityLegalDeclarations([id]))
        if (response) {
          await logEvent('CGI - unLockDeclarations', {
            body: [id],
            response: response
          })
          handleSuccess()
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <>
      <div className={classes.root}>
        {/* <SearchBarAndFiltersOrganization
          rows={rows}
          setRows={setRows}
          setLoading={setLoading}
          openFilterByType={openFilterByType}
          setopenFilterByType={setopenFilterByType}
          valueFilter={valueFilter}
          setvalueFilter={setvalueFilter}
        /> */}
        {elementsChecked.length > 0 && (
          <tr>
            <td>
              <Button className={classes.button} onClick={handleButtonClick}>
                <LockOpenOutlinedIcon />
                Desbloquear
              </Button>
            </td>
          </tr>
        )}
        <div className={classes.tableWrap}>
          <table className={classes.table}>
            <TableHeader
              allChecked={allChecked}
              setAllChecked={setAllChecked}
              setElementsChecked={setElementsChecked}
            />

            <tbody className={classes.tableBody}>
              {rows &&
                rows.map((item, index) => (
                  <TableItem
                    listIndex={index}
                    key={item.organizationId}
                    item={item}
                    allChecked={allChecked}
                    setAllChecked={setAllChecked}
                    elementsChecked={elementsChecked}
                    setElementsChecked={setElementsChecked}
                    id={id}
                    onDesbloquear={handleUnLockSingleDeclaration}
                    getUserName={getUserName}
                    getCustomerName={getCustomerName}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default DeclarationTable
